import React from "react";
import { Tooltip, TooltipProps } from "antd";

// components
import TooltipCampaignListContent from "./TooltipCampaignListContent";

// helpers
import { useDimension } from "../../hooks/useDimensions";

// assets
import styles from "@/assets/styles/components/tooltip-campaign-list.module.scss";

type ITooltipCampaignList = TooltipProps & {
  campaigns: number[];
  campaignsNames: string[];
  isShowOnlyOnDesktop?: boolean;
  children?: React.ReactNode;
}

const TooltipCampaignList = (props: ITooltipCampaignList) => {
  const { campaigns = [], campaignsNames = [], isShowOnlyOnDesktop, children, ...rest } = props;
  const [width] = useDimension();

  const isDesktop = width > 1280;

  if (!campaigns.length || !campaignsNames.length || (isShowOnlyOnDesktop && !isDesktop)) {
    return children;
  }

  return (
    <Tooltip
      placement="bottom"
      title={<TooltipCampaignListContent campaigns={campaigns} campaignsNames={campaignsNames} />}
      overlayClassName={styles["locl-tooltip-campaign-list"]}
      {...rest}
    >
      {children}
    </Tooltip>
  );
};

export default TooltipCampaignList;
